export function getSingleErrorMessage(httpResponse) {  
  debugger
    if (httpResponse.request?.status === 404) {
      if (httpResponse.request.response) {        
        const requestData = JSON.parse(httpResponse.request.response);                
        const { message } = requestData;   
        if (message) {
          return message;
        }
      }
    }
    if (httpResponse.request?.status === 400) {
      if (httpResponse.request.response) {
        console.log(httpResponse.request.response);
        const request = JSON.parse(httpResponse.request.response);
        console.log(request);
        return request.length > 0 ? request[0].message : request.message;
      }
    }
    return "Não foi possível logar na sua conta. Estamos com instabilidades no site, por favor, tente mais tarde.";
  }